let alerts = {
    init: () => {
        const alerts = document.querySelectorAll('.js-alert');

        const closeAlert = (alert) => {
            return () => {
                alert.style.opacity = "0";
                setTimeout(() => {
                    alert.hidden = true;
                }, 300);
            }
        }

        if(alerts) {
            for(const alert of alerts) {
                const closeBtn = alert.querySelector('.js-alert-close');

                if(closeBtn)
                    closeBtn.addEventListener('click', closeAlert(alert));
            }
        }
    }
}

export default alerts;